var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgKeyboardOnscreen = function SvgKeyboardOnscreen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "keyboard_onscreen_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#keyboard_onscreen_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 21.106h7.5q.46 0 .782-.318a1.06 1.06 0 0 0 .324-.788q0-.46-.324-.782a1.07 1.07 0 0 0-.782-.324h-7.5q-.459 0-.783.318a1.06 1.06 0 0 0-.323.788q0 .46.323.782.324.324.783.324m-5.865 3.269a2.18 2.18 0 0 1-1.604-.656 2.18 2.18 0 0 1-.656-1.604V7.885q0-.948.656-1.604a2.18 2.18 0 0 1 1.604-.656h19.23q.948 0 1.604.656t.656 1.604v14.23q0 .948-.656 1.604a2.18 2.18 0 0 1-1.604.656zM5 11.563h20V7.885a.37.37 0 0 0-.12-.265.37.37 0 0 0-.265-.12H5.385a.37.37 0 0 0-.265.12.37.37 0 0 0-.12.265zm2.5 5.793q.459 0 .783-.324.323-.323.323-.782t-.323-.783a1.07 1.07 0 0 0-.783-.323q-.46 0-.782.323a1.07 1.07 0 0 0-.324.783q0 .46.324.782.323.324.782.324m3.75 0q.459 0 .783-.324.323-.323.323-.782t-.323-.783a1.07 1.07 0 0 0-.783-.323q-.459 0-.783.323a1.07 1.07 0 0 0-.323.783q0 .46.323.782.324.324.783.324m3.75 0q.459 0 .783-.324.323-.323.323-.782t-.324-.783a1.07 1.07 0 0 0-.782-.323q-.459 0-.783.323a1.07 1.07 0 0 0-.323.783q0 .46.323.782.324.324.783.324m3.75 0q.46 0 .782-.324.324-.323.324-.782t-.324-.783a1.07 1.07 0 0 0-.782-.323q-.46 0-.782.323a1.07 1.07 0 0 0-.324.783q0 .46.324.782.323.324.782.324m3.75 0q.46 0 .782-.324.324-.323.324-.782t-.324-.783a1.07 1.07 0 0 0-.782-.323q-.46 0-.782.323a1.07 1.07 0 0 0-.324.783q0 .46.324.782.323.324.782.324"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKeyboardOnscreen);
export default ForwardRef;